
import {getPlugin}  from "../../services/apis";
import {thirdPartyPlugins} from "./editorUtils"

export const gereratePluginsList =()=>{

  let list=[];

    getPlugin((response, err, errorCode) => {
        if (err) {
          // refSaveLoading.current = true;
       
         
        } else {
          const sortedLib = response.data.sort((a, b) => a.order - b.order);
          sortedLib.forEach((item)=>{list.push({   "name": item.name,
           "url": item.link,
           "status": 1})})
        }
      });
     
  return list||thirdPartyPlugins;
}